
















import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";

import XsyxHomeFa from "./XsyxHomeFa.vue";
import UserInfo from "../user/UserInfo.vue";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
    XsyxHomeFa,
    UserInfo,
  },
})
export default class XsyhHome extends mixins(WeMixin) {
  protected created() {
    this.getCustomerInfo();
  }

  private getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      console.log(res.data);
      if (res.data.flag === "0") {
        if (res.data.accounttype === "0") {
          this.$router.push("/main/user/userInfo");
        } else if (res.data.accounttype === "1") {
          this.$router.push("/main/user/userInfoMerchant");
        }
      } else if (res.data.flag === "1") {
        this.$router.push("/main/user/register");
      }
    });
  }
}
